"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildCursor = void 0;
class ChildCursor {
    constructor(nodes) {
        this.nodes = nodes;
        this.pos = 0;
    }
    get done() {
        return this.pos >= this.nodes.length;
    }
    get index() {
        return this.pos;
    }
    nodeAt(index) {
        return this.nodes[index];
    }
    peekType() {
        if (this.done) {
            return null;
        }
        return this.nodes[this.pos].type;
    }
    consumeAtoms() {
        const atoms = [];
        while (!this.done && this.nodes[this.pos].type === 'atom') {
            const node = this.nodes[this.pos];
            if (node.type === 'atom') {
                atoms.push(node.content);
            }
            this.pos++;
        }
        return atoms;
    }
    takePayload() {
        if (this.done) {
            throw new Error('ChildCursor: takePayload called past end of child list');
        }
        const node = this.nodes[this.pos];
        if (node.type === 'atom') {
            throw new Error(`ChildCursor: takePayload called when next node is an atom ("${node.content}") — call consumeAtoms() first`);
        }
        const index = this.pos;
        this.pos++;
        return { node: node, index };
    }
    takeContainer() {
        if (this.done) {
            return null;
        }
        const node = this.nodes[this.pos];
        if (node.type !== 'container' && node.type !== 'econtainer') {
            return null;
        }
        const index = this.pos;
        this.pos++;
        return { node, index };
    }
    takeName() {
        if (this.done) {
            return null;
        }
        const node = this.nodes[this.pos];
        if (node.type !== 'name') {
            return null;
        }
        const index = this.pos;
        this.pos++;
        return { node, index };
    }
    takeValue() {
        if (this.done) {
            return null;
        }
        const node = this.nodes[this.pos];
        if (node.type !== 'value') {
            return null;
        }
        const index = this.pos;
        this.pos++;
        return { node, index };
    }
}
exports.ChildCursor = ChildCursor;
//# sourceMappingURL=cursor.js.map